<template>
  <div>
    <v-dialog v-model="dialog.master" 
      persistent
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 white--text light-green lighten-2">
          Tambah Dokumen
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-form class="pt-5 pb-0">
              <ValidationProvider name="Nama Dokumen" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Nama Dokumen"
                  prepend-inner-icon="mdi-text-box-plus-outline"
                  :color="style.primary"
                  v-model="form.description"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>
          <v-alert 
            class="mx-10 mt-10"
            type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-divider class="mx-4 my-2"/>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            small
            :color="style.primary"
            elevation="3"
            class="text-capitalize white--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="saveMaster">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize red--text mx-1"
            :disabled="process.form"
            @click="dialog.master = false; form.description = ''; $refs.observer.reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.form" 
      persistent
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 white--text light-green lighten-2 d-flex align-center"
          style="position: fixed; width: 500px; z-index: 9;">
          <span>
            Pilih Dokumen
          </span>
          <v-spacer/>
          <span class="cursor-pointer" @click="dialog.master = true; form.description = '';">
            <v-icon color="white" small>mdi-plus</v-icon>
            Master
          </span>
        </v-card-title>
        <v-card-text style="height: 500px; overflow: scroll;">
          <v-form class="pt-16 pb-0">
            <v-checkbox 
              dense
              hide-details
              :color="style.primary"
              class="mt-1"
              style="font-size: 10px !important"
              v-for="(item, index) in master"
              :key="index"
              :label="item.mortage_description" 
              :value="item.mortage_id"
              v-model="form.mortage_id">
            </v-checkbox>
          </v-form>
          <v-alert 
            class="mx-10 mt-10"
            type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            small
            :color="style.primary"
            elevation="3"
            class="text-capitalize white--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="save">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize red--text mx-1"
            :disabled="process.form"
            @click="reset()">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-container class="py-0"> -->
      <v-row>
        <v-col cols="12" class="py-0">
          <v-card flat min-height="800">
            <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0':''">
              <v-row>
                <v-col cols="8" class="py-0">
                  <v-btn v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')"
                    :color="style.primary"
                    elevation="3"
                    class="text-capitalize white--text"
                    @click="reset()">
                    <v-icon small class="mr-1">mdi-plus</v-icon>
                    Dokumen
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mx-4" v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')"/>
            <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0 py-0':'py-0'" style="min-height: 650px;">
              <v-skeleton-loader
                :loading="process.run"
                transition="scale-transition"
                :tile="false"
                type="table-tbody">
                <v-simple-table>
                  <template v-slot:default>
                    <thead v-if="!process.run && list.length > 0">
                      <tr>
                        <th class="text-left pl-0">Nama Dokumen</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr 
                        v-for="(item, index) in list" 
                        :key="index">
                        <td class="text-second text-capitalize pl-0">
                          {{ item.mortage_description }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-skeleton-loader>

              <div class="d-flex text-center text--secondary my-16 py-16" style="min-height: 550px;" v-if="!process.run && list.length < 1">
                <v-img 
                  class="my-16 py-16"
                  contain
                  width="200"
                  height="200"
                  :src="require('@/assets/404/404.svg')">
                </v-img>
              </div>
              <v-divider/>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    <!-- </v-container> -->
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  export default {
    data () {
      return {
        dialog: {
          form: false,
          master: false
        },
        master: [],
        list: [],
        form: {
          description: '',
          mortage_id: []
        },
        process: {
          run: false,
          form: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      
    },
    mounted () {
      this.fetchMaster()
      this.fetch()
    },
    methods: {
      async fetchMaster() {
        await get(`auth/mortage-document/list-option`)
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.master = res.data.results
          }
        })
      },
      async fetch() {
        this.process.run = true

        await get(`auth/mortage-document-company/detail`)
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            
            if (Object.keys(res.data).length > 0) {
              this.list = res.data.ref_mortage_mortage_id
  
              this.form.mortage_id = []
              for(let i in this.list) {
                this.form.mortage_id.push(this.list[i].mortage_id)
              }
            }
          }
        })
      },
      reset(item) {
        this.dialog.form = !this.dialog.form ? true : false

        this.process.form = false

        this.error.message = ''
      },
      async save() {
        this.error.message = ''
        this.process.form = true
        await post(`auth/mortage-document-company/create`, {
          data: {
            mortage_id: JSON.stringify(this.form.mortage_id)
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.reset()
            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      },
      async saveMaster() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true
          await post(`auth/mortage-document/create`, {
            data: {
              description: this.form.description
            }
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.process.form = false
              this.dialog.master = false
              this.form.description = ''
              this.fetchMaster()
              this.fetch()
            } else {
              this.process.form = false
              this.error.message = res.msg
            }
          })
        }
      }
    }
  }
</script>